<script setup>
// RM-359 PR 3 (Kapil and the product agent, 10/27): the Likelihood of
// Acceptance in RM AI's chat, right above its Review & Submit button, for
// every member, with "Ask RM for feedback first" — the same card and button
// the request's "Before you submit" step shows. Read once, for a request not
// yet submitted (the endpoint answers null for any other).
// RM-359 (Kapil 10/29): until RM turns the likelihood on for members, only
// Ask RM for feedback shows here; the read still scores it for #request-scores.
import axios from '@axios'
import { onMounted, ref } from 'vue'
import AskRmFeedback from '@core/components/AskRmFeedback.vue'
import LikelihoodCard from '@core/components/LikelihoodCard.vue'
import { noteLikelihoodAnswer, placeholderWhile } from '@/utils/likelihoodVisibility'

const props = defineProps({
  reservationId: { type: String, required: true },
})

const likelihood = ref(null)
const feedback = ref(false)
const loading = ref(true)

onMounted(async () => {
  try {
    const { data } = await axios.get(`/reservation/${props.reservationId}/likelihood`, { params: { from: 'chat' } })
    noteLikelihoodAnswer(data)
    likelihood.value = data?.likelihood || null
    feedback.value = !!data?.feedback
  } catch (error) {
    likelihood.value = null
  } finally {
    loading.value = false
  }
})
</script>

<template>
  <div
    v-if="placeholderWhile(loading) || likelihood || feedback"
    class="agent-request-likelihood"
  >
    <LikelihoodCard
      :likelihood="likelihood"
      :loading="placeholderWhile(loading)"
    />
    <AskRmFeedback
      v-if="likelihood || feedback"
      :reservation-id="reservationId"
      :save-first="false"
      class="mb-3"
    />
  </div>
</template>

<style scoped>
.agent-request-likelihood {
  margin: 8px 0 4px;
}
</style>
